import { UAParser } from 'ua-parser-js'
export const isMac = (): boolean => {
  const parser = new UAParser()
  return parser.getOS()?.name === 'Mac OS'
}
